export default __webpack_public_path__ + "static/media/band5.4dcb4164.jfif";